var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_vm._v("This is vue projection grid - basic demo")]),
      _vm._v(" "),
      _c("grid", { attrs: { config: _vm.config } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-381730fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// D:/codebase/vue-projection-grid/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381730fa","hasScoped":false,"buble":{"transforms":{}}}!D:/codebase/vue-projection-grid/node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app.vue
// module id = 12
// module chunks = 0